import React from "react";
import { NavLink } from "react-router-dom";

function Footer() {
  return (
    <>
      <section className="pt-10 md:pt-10 pb-4 bg-[#001E0E] relative overflow-hidden">
        {/* Glossy overlay effect */}
        {/* <div className="absolute inset-0 bg-gradient-to-br from-white/5 via-transparent to-white/10 pointer-events-none"></div>
                <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/20 to-transparent"></div>
                 */}
        <div className="grid grid-cols-2 gap-8 md:grid-cols-3 lg:grid-cols-12 px-8 lg:px-16 relative z-10 justify-items-center lg:justify-items-start">
          <div className="col-span-3 justify-items-center mb-6">
            <NavLink to="/" className="flex justify-center">
              <img src="/images/afripay-logo.png" alt="logo" className="" />
            </NavLink>
            <p className="text-[#B8B8B8] my-5 font-body font-medium text-sm">
              <strong>
                AfriPay is a technology and financial services platform, not a
                bank.
              </strong>
              We empower individuals and businesses across Africa with seamless
              cross-border payment solutions through partnerships with licensed
              financial institutions.
            </p>
            <div className="mt-[30px]">
              {/* <form>

                                <div className="relative">

                                    <input type="email" id="email" className="block w-full p-4 text-sm text-gray-900 border-[2px] border-[#A6A6A6] rounded-[70px] bg-transparent" placeholder="Enter your email here" required />
                                    <button type="submit" className=" absolute right-2 bottom-1">
                                        <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="23" cy="23" r="23" fill="#209D5A" />
                                            <path d="M16 23H30" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M23 16L30 23L23 30" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>


                                    </button>
                                </div>
                            </form> */}
            </div>
          </div>
          {/* <div className=' col-span-1 hidden md:block'></div> */}
          {/* <div className=' col-span-2 mt-3'> */}
          {/* <h4 className='text-[#ffffff] text-[16px] md:text-[18px] font-medium mb-6'>Powered by</h4> */}
          {/* <h3 className='mb-[12px] text-[16px] md:text-[18px] font-medium text-[#A6A6A6]'>MasterCard Lighthouse</h3> */}
          {/* <h3 className='mb-[12px] text-[16px] md:text-[18px] font-medium text-[#A6A6A6]'>Wema Bank</h3> */}
          {/* <h3 className='mb-2 text-[16px] md:text-[18px] font-medium text-[#A6A6A6]'>Interswitch</h3> */}
          {/* <h3 className='mb-[12px] text-[16px] md:text-[18px] font-medium text-[#A6A6A6]'>Flutterwave</h3> */}
          {/* <h3 className='mb-2 text-[16px] md:text-[18px] font-medium text-[#A6A6A6]'>Verto</h3> */}
          {/* </div> */}
          <div className=" col-span-2 text-center lg:text-left">
            <h4 className="text-[#ffffff] text-base md:text-lg font-display font-semibold mb-4">
              Product
            </h4>

            <NavLink to="/currency-converter">
              <h3 className="mb-[12px] text-sm md:text-base font-body font-medium text-[#B8B8B8] hover:text-white transition-colors duration-300">
                Currency Exchange
              </h3>
            </NavLink>

            <NavLink to="/gobal-account">
              <h3 className="mb-[12px] text-sm md:text-base font-body font-medium text-[#B8B8B8] hover:text-white transition-colors duration-300">
                Multi-Currency Accounts
              </h3>
            </NavLink>

            <NavLink to="/money-transfer">
              <h3 className="mb-[12px] text-sm md:text-base font-body font-medium text-[#B8B8B8] hover:text-white transition-colors duration-300">
                Cash Transfer
              </h3>
            </NavLink>

            <NavLink to="/bills-payment">
              <h3 className="mb-[12px] text-sm md:text-base font-body font-medium text-[#B8B8B8] hover:text-white transition-colors duration-300">
                Bill/Tax Payments
              </h3>
            </NavLink>

            <NavLink to="/vitual-card-page">
              <h3 className="mb-[12px] text-sm md:text-base font-body font-medium text-[#B8B8B8] hover:text-white transition-colors duration-300">
                Afripay Card
              </h3>
            </NavLink>

            {/* <h3 className='mb-[12px] text-[14px] md:text-[16px] font-[400] text-[#A6A6A6]'>Wema Bank</h3> */}
            {/* <h3 className='mb-2 text-[14px] md:text-[16px] font-[400] text-[#A6A6A6]'>Interswitch</h3> */}
            {/* <h3 className='mb-[12px] text-[14px] md:text-[16px] font-[400] text-[#A6A6A6]'>Flutterwave</h3> */}
            {/* <h3 className='mb-2 text-[14px] md:text-[16px] font-[400] text-[#A6A6A6]'>Verto</h3> */}
          </div>
          <div className=" col-span-2 text-center lg:text-left">
            <h4 className="text-[#ffffff] text-base md:text-lg font-display font-semibold mb-4">
              Company
            </h4>
            <NavLink to="/about-us">
              <h3 className="mb-[12px] text-sm md:text-base font-body font-medium text-[#B8B8B8] hover:text-white transition-colors duration-300">
                About Us
              </h3>
            </NavLink>
            {/* <NavLink to="/">
                            <h3 className='mb-[12px] text-sm md:text-base font-body font-medium text-[#B8B8B8] hover:text-white transition-colors duration-300'>Careers</h3>
                        </NavLink> */}
            <NavLink to="/terms-of-use">
              <h3 className="mb-2 text-sm md:text-base font-body font-medium text-[#B8B8B8] hover:text-white transition-colors duration-300">
                Term of Service
              </h3>
            </NavLink>
            <NavLink to="https://sandbox-business.goafripay.com/">
              <h3 className="mb-[12px] text-sm md:text-base font-body font-medium text-[#B8B8B8] hover:text-white transition-colors duration-300">
                Afripay Business
              </h3>
            </NavLink>

            <NavLink to="https://afriproedu.com/">
              <h3 className="mb-[12px] text-sm md:text-base font-body font-medium text-[#B8B8B8] hover:text-white transition-colors duration-300">
                Afriproedu
              </h3>
            </NavLink>
            {/* <NavLink to="/">
                        <h3 className='mb-2 text-[14px] md:text-[16px] font-[400] text-[#A6A6A6]'>Blog</h3>
                        </NavLink> */}
          </div>

          <div className=" col-span-2 text-center lg:text-left">
            <h4 className="text-[#ffffff] text-base md:text-lg font-display font-semibold mb-4">
              Resources
            </h4>

            <NavLink to="/faq">
              <h3 className="mb-[12px] text-sm md:text-base font-body font-medium text-[#B8B8B8] hover:text-white transition-colors duration-300">
                FAQ
              </h3>
            </NavLink>

            <NavLink to="/blog">
              <h3 className="mb-[12px] text-sm md:text-base font-body font-medium text-[#B8B8B8] hover:text-white transition-colors duration-300">
                Blog
              </h3>
            </NavLink>

            <NavLink to="/contact-us">
              <h3 className="mb-[12px] text-sm md:text-base font-body font-medium text-[#B8B8B8] hover:text-white transition-colors duration-300">
                Support
              </h3>
            </NavLink>

            {/* <NavLink to="/tuition-payment">
                            <h3 className='mb-[12px] text-sm md:text-base font-body font-medium text-[#B8B8B8] hover:text-white transition-colors duration-300'>Tuition Payment</h3>
                        </NavLink> */}

            {/* <NavLink to="/student-loan">
                            <h3 className='mb-[12px] text-sm md:text-base font-body font-medium text-[#B8B8B8] hover:text-white transition-colors duration-300'>Loans</h3>
                        </NavLink> */}

            {/* <NavLink to="/savings-with-afripay">
                        <h3 className='mb-[12px] text-[14px] md:text-[16px] font-[400] text-[#A6A6A6]'>Savings</h3>
                        </NavLink> */}

            {/* <NavLink to="/afripayshop">
                            <h3 className='mb-2 text-sm md:text-base font-body font-medium text-[#B8B8B8] hover:text-white transition-colors duration-300'>AfriPay Shop</h3>
                        </NavLink> */}

            {/* <h3 className='mb-2 text-[14px] md:text-[16px] font-[400] text-[#A6A6A6]'>Proof of Funds</h3> */}
          </div>
          <div className=" col-span-3 text-center lg:text-left">
            <h4 className="text-[#ffffff] text-base md:text-lg font-display font-semibold mb-4">
              Connect With US
            </h4>
            <h3 className="mb-[12px] text-sm md:text-base font-body font-medium text-[#B8B8B8]">
              <strong>Nigeria:</strong> 3, Samuel Ajakaiye street, Lagos,
              Nigeria.{" "}
            </h3>
            <h3 className="mb-[12px] text-sm md:text-base font-body font-medium text-[#B8B8B8]">
              <strong>United States:</strong> 131 Continental Drive, Suite 305,
              Newark, DE 19713, USA.{" "}
            </h3>
            <h3 className="mb-[12px] text-sm md:text-base font-body font-medium text-[#B8B8B8]">
              Learn more about AfriPay, connect with us, and join us in shaping
              the future of cross-border payments across Africa.
            </h3>
            <div className="flex justify-center lg:justify-start space-x-6">
              {/* instagram */}
              <a
                href="https://www.instagram.com/afripaygo?igsh=amZmNG80djRlNDh6"
                target="_blank"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.493 1.66675H6.50964C3.4763 1.66675 1.66797 3.47508 1.66797 6.50841V13.4834C1.66797 16.5251 3.4763 18.3334 6.50964 18.3334H13.4846C16.518 18.3334 18.3263 16.5251 18.3263 13.4917V6.50841C18.3346 3.47508 16.5263 1.66675 13.493 1.66675ZM10.0013 13.2334C8.21797 13.2334 6.76797 11.7834 6.76797 10.0001C6.76797 8.21675 8.21797 6.76675 10.0013 6.76675C11.7846 6.76675 13.2346 8.21675 13.2346 10.0001C13.2346 11.7834 11.7846 13.2334 10.0013 13.2334ZM14.9346 5.73341C14.893 5.83341 14.8346 5.92508 14.7596 6.00841C14.6763 6.08341 14.5846 6.14175 14.4846 6.18341C14.3846 6.22508 14.2763 6.25008 14.168 6.25008C13.943 6.25008 13.7346 6.16675 13.5763 6.00841C13.5013 5.92508 13.443 5.83341 13.4013 5.73341C13.3596 5.63341 13.3346 5.52508 13.3346 5.41675C13.3346 5.30841 13.3596 5.20008 13.4013 5.10008C13.443 4.99175 13.5013 4.90841 13.5763 4.82508C13.768 4.63341 14.0596 4.54175 14.3263 4.60008C14.3846 4.60841 14.4346 4.62508 14.4846 4.65008C14.5346 4.66675 14.5846 4.69175 14.6346 4.72508C14.6763 4.75008 14.718 4.79175 14.7596 4.82508C14.8346 4.90841 14.893 4.99175 14.9346 5.10008C14.9763 5.20008 15.0013 5.30841 15.0013 5.41675C15.0013 5.52508 14.9763 5.63341 14.9346 5.73341Z"
                    fill="white"
                    fill-opacity="0.8"
                  />
                </svg>
              </a>
              {/* facebook */}
              <a
                href="https://www.facebook.com/share/1Ai9hjBSBJ/?mibextid=wwXIfr"
                target="_blank"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.3346 13.4917C18.3346 16.5251 16.5263 18.3334 13.493 18.3334H12.5013C12.043 18.3334 11.668 17.9584 11.668 17.5001V12.6918C11.668 12.4668 11.8513 12.2751 12.0763 12.2751L13.543 12.2501C13.6596 12.2418 13.7596 12.1584 13.7846 12.0418L14.0763 10.4501C14.1013 10.3001 13.9846 10.1584 13.8263 10.1584L12.0513 10.1834C11.818 10.1834 11.6346 10.0001 11.6263 9.77509L11.593 7.73341C11.593 7.60008 11.7013 7.48342 11.843 7.48342L13.843 7.45008C13.9846 7.45008 14.093 7.34176 14.093 7.20009L14.0596 5.20007C14.0596 5.05841 13.9513 4.95008 13.8096 4.95008L11.5596 4.98342C10.1763 5.00842 9.07631 6.14175 9.10131 7.52508L9.14297 9.81675C9.1513 10.0501 8.96798 10.2334 8.73464 10.2418L7.73463 10.2584C7.59297 10.2584 7.48464 10.3667 7.48464 10.5084L7.50964 12.0918C7.50964 12.2334 7.61797 12.3417 7.75963 12.3417L8.75964 12.3251C8.99298 12.3251 9.17629 12.5084 9.18463 12.7334L9.25962 17.4834C9.26796 17.9501 8.89296 18.3334 8.42629 18.3334H6.50963C3.4763 18.3334 1.66797 16.5251 1.66797 13.4834V6.50841C1.66797 3.47508 3.4763 1.66675 6.50963 1.66675H13.493C16.5263 1.66675 18.3346 3.47508 18.3346 6.50841V13.4917Z"
                    fill="white"
                    fill-opacity="0.8"
                  />
                </svg>
              </a>
              {/* twitter */}
              <a
                href="https://x.com/goafripay?s=11&t=8Y0Pr_VTIrnse_LLkDOq9w"
                target="_blank"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_14741_94209)">
                    <mask
                      id="mask0_14741_94209"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="20"
                      height="20"
                    >
                      <path d="M0 0H20V20H0V0Z" fill="white" />
                    </mask>
                    <g mask="url(#mask0_14741_94209)">
                      <path
                        d="M15.75 0.937256H18.8171L12.1171 8.6144L20 19.063H13.8286L8.99143 12.7273L3.46286 19.063H0.392857L7.55857 10.8487L0 0.938684H6.32857L10.6943 6.72868L15.75 0.937256ZM14.6714 17.223H16.3714L5.4 2.68154H3.57714L14.6714 17.223Z"
                        fill="#D0D2D4"
                      />
                    </g>
                  </g>
                  <defs>
                    <clipPath id="clip0_14741_94209">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </a>
              {/* linkedin */}
              <a
                href="https://www.linkedin.com/company/goafripay/"
                target="_blank"
              >
                <svg
                  width="24"
                  height="23"
                  viewBox="0 0 24 23"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.3922 2.81512C18.8899 2.81512 19.3673 3.01285 19.7192 3.36481C20.0712 3.71677 20.2689 4.19413 20.2689 4.69188V17.8291C20.2689 18.3269 20.0712 18.8042 19.7192 19.1562C19.3673 19.5082 18.8899 19.7059 18.3922 19.7059H5.25492C4.75718 19.7059 4.27982 19.5082 3.92786 19.1562C3.5759 18.8042 3.37817 18.3269 3.37817 17.8291V4.69188C3.37817 4.19413 3.5759 3.71677 3.92786 3.36481C4.27982 3.01285 4.75718 2.81512 5.25492 2.81512H18.3922ZM17.923 17.3599V12.3866C17.923 11.5752 17.6007 10.7971 17.027 10.2234C16.4533 9.64975 15.6752 9.32745 14.8639 9.32745C14.0663 9.32745 13.1373 9.8154 12.6869 10.5473V9.50574H10.0688V17.3599H12.6869V12.7338C12.6869 12.0112 13.2687 11.42 13.9912 11.42C14.3396 11.42 14.6738 11.5584 14.9201 11.8048C15.1665 12.0512 15.3049 12.3853 15.3049 12.7338V17.3599H17.923ZM7.01907 8.03249C7.43718 8.03249 7.83816 7.8664 8.1338 7.57075C8.42945 7.27511 8.59554 6.87413 8.59554 6.45602C8.59554 5.58333 7.89176 4.87017 7.01907 4.87017C6.59848 4.87017 6.19511 5.03725 5.8977 5.33465C5.6003 5.63206 5.43322 6.03543 5.43322 6.45602C5.43322 7.32871 6.14638 8.03249 7.01907 8.03249ZM8.32341 17.3599V9.50574H5.72411V17.3599H8.32341Z"
                    fill="white"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>

        {/* <div className='flex flex-col lg:flex-row lg:justify-between mt-16 px-8 lg:px-16 relative z-10'>
                    <p className='text-[#B8B8B8] text-lg md:text-xl font-body font-medium'>All our financial services are provided by our partners</p>
                </div> */}
        <div className="flex flex-col lg:flex-row lg:justify-between mt-10 px-8 lg:px-16 relative z-10 text-center lg:text-left">
          <div>
            <p className="text-white text-sm md:text-base font-body font-medium">
              ©2025 AfriPay. Copyright and rights reserved
            </p>
          </div>
          <div className="flex space-x-2 mt-3 justify-center lg:justify-start">
            <NavLink to="/terms-of-use">
              <p className="text-white text-sm md:text-base font-body font-medium hover:text-white transition-colors duration-300">
                Terms of Use
              </p>
            </NavLink>

            <p className="text-white text-sm md:text-base">.</p>
            <NavLink to="/privacy-policy">
              <p className="text-white text-sm md:text-base font-body font-medium hover:text-white transition-colors duration-300">
                Privacy Policy
              </p>
            </NavLink>
          </div>
        </div>
      </section>
    </>
  );
}

export default Footer;
